import { z } from 'zod';

export const systemMailSchema = z.object({
  idSystemMail: z.number(),
  idSystemMailCategory: z.number(),
  Title: z.string(),
  Subject: z.string(),
  Body: z.string(),
  InfoText: z.string().nullable(),
  isPublic: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(false),
  isHidden: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(false),
});

export type ISystemMail = z.infer<typeof systemMailSchema>;
